module.exports = __webpack_public_path__ + "static/media/iconFormationActive.3812a878.svg";